import { Time } from '@angular/common';
import { BcmOrder, BcmOrderDto } from './bcm-order';
import { BcmOrderTaskPositionStatusType } from './bcm-order-status';
import { normalizeTaskPositionStatus, resolveTaskPositionDoneFlag } from '@shared/helpers/order-status-model.util';
import { OrderTaskPositionAssigneeType } from '@shared/helpers/order-task-position-assignee.util';

export interface BcmOrderTodoDto {
    id: number;
    bcm_orders_id: number;
    todo: string;
    duration: Time;
    done: boolean;
    taskStatus?: BcmOrderTaskPositionStatusType;
    statusNote?: string | null;
    position: number;
    note: string;
    assigneeType?: OrderTaskPositionAssigneeType | null;
    bcm_employees_id?: number | null;
    bcm_departments_id?: number | null;
    externalCompanyName?: string | null;
    insertedOn: Date;
    insertedBy: string;
    lastUpdateOn: Date;
    lastUpdateBy: string;
    order: BcmOrderDto;
}

export class BcmOrderTodo {
    id: number;
    bcm_orders_id: number;
    todo: string;
    duration: Time;
    done: boolean;
    taskStatus: BcmOrderTaskPositionStatusType;
    statusNote: string | null;
    position: number;
    note: string;
    assigneeType: OrderTaskPositionAssigneeType | null;
    bcm_employees_id: number | null;
    bcm_departments_id: number | null;
    externalCompanyName: string | null;
    readonly insertedOn: Date;
    readonly insertedBy: string;
    readonly lastUpdateOn: Date;
    readonly lastUpdateBy: string;
    order: BcmOrder | null;

    constructor(bcmOrderWorkPackageDto: BcmOrderTodoDto = {} as BcmOrderTodoDto) {
        this.id = bcmOrderWorkPackageDto.id;
        this.bcm_orders_id = bcmOrderWorkPackageDto.bcm_orders_id;
        this.todo = bcmOrderWorkPackageDto.todo;
        this.duration = bcmOrderWorkPackageDto.duration;
        this.taskStatus = normalizeTaskPositionStatus(
            bcmOrderWorkPackageDto.taskStatus,
            bcmOrderWorkPackageDto.done,
        );
        this.done = resolveTaskPositionDoneFlag(this.taskStatus);
        this.statusNote = bcmOrderWorkPackageDto.statusNote ?? null;
        this.position = bcmOrderWorkPackageDto.position;
        this.note = bcmOrderWorkPackageDto.note;
        this.assigneeType = bcmOrderWorkPackageDto.assigneeType ?? null;
        this.bcm_employees_id = bcmOrderWorkPackageDto.bcm_employees_id ?? null;
        this.bcm_departments_id = bcmOrderWorkPackageDto.bcm_departments_id ?? null;
        this.externalCompanyName = bcmOrderWorkPackageDto.externalCompanyName ?? null;
        this.insertedOn = bcmOrderWorkPackageDto.insertedOn;
        this.insertedBy = bcmOrderWorkPackageDto.insertedBy;
        this.lastUpdateOn = bcmOrderWorkPackageDto.lastUpdateOn;
        this.lastUpdateBy = bcmOrderWorkPackageDto.lastUpdateBy;

        this.order = bcmOrderWorkPackageDto.order ? new BcmOrder(bcmOrderWorkPackageDto.order) : null;
    }
}
